import BaseApi from './baseApi';
import IRPTRepports from '../models/IRPTRepports';
import IAuthentication from '../models/IAuthentication';
export default class RPTRepportsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Reports");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRPTRepports() : Promise<IRPTRepports[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var repports: IRPTRepports[] = [];
            repports = response.data as IRPTRepports[];
            return repports;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRPTRepports(repport: IRPTRepports) : Promise<string> {
        const json = this.getJsonSave(repport);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRPTRepports(repport: IRPTRepports) : Promise<boolean> {
        const json = this.getJsonUpdate(repport);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRPTRepports(repportsId: string) : Promise<boolean> {
        const json = this.getJsonDelete(repportsId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(idRepports: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Repports",
            "conditions": [{
                "Item1": "RPT_Repports",
                "Item2": "id",
                "Item3": "=",
                "Item4": idRepports
            }]
        };
        return json;
    }

    private getJsonSave(repport: IRPTRepports) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompany",
                "Item2": repport.idCompany
            }, {
                "Item1": "repportName",
                "Item2": repport.repportName
            }, {
                "Item1": "templateFilePath",
                "Item2": repport.templateFilePath
            }, {
                "Item1": "isUserVisible",
                "Item2": repport.isUserVisible
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Repports"
        };
        return json;
    }

    private getJsonUpdate(repport: IRPTRepports) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompany",
                "Item2": repport.idCompany
            }, {
                "Item1": "repportName",
                "Item2": repport.repportName
            }, {
                "Item1": "templateFilePath",
                "Item2": repport.templateFilePath
            }, {
                "Item1": "isUserVisible",
                "Item2": repport.isUserVisible
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Repports",
            "keyvalue": repport.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "RPT_Repports",
                "Item2": "id"
            }, {
                "Item1": "RPT_Repports",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "RPT_Repports",
                "Item2": "repportName"
            }, {
                "Item1": "RPT_Repports",
                "Item2": "templateFilePath"
            }, {
                "Item1": "RPT_Repports",
                "Item2": "isUserVisible"
            }],
            "tables": [{
                "Item1": "RPT_Repports"
            }, {
                "Item1": "Companies"
            }],
            "joins": [{
                "Item1": "RPT_Repports",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "RPT_Repports",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
